import React, { Component } from "react";
import { Portal } from "react-portal";
import FadeIn from "react-lazyload-fadein";

export default class ArticleGalleryImage extends React.Component {
		
	state = { isOpen: false };

	handleZoom = () => {
    	this.setState({ isOpen: !this.state.isOpen });
  	};

	render() {
		
		return (
			<div onClick={this.handleZoom} className={'c-article__images__thumb c-article__images__thumb--' + this.props.image.fitting}>
	    		<div className="c-article__images__thumb__inner">
		    		<FadeIn duration={250}>
						{onload => (
							<img
								src={this.props.image.src} 
								srcSet={this.props.image.srcset} 
								onLoad={onload}
							/>
						)}
					</FadeIn>
				</div>
				<Portal>
					<div className={'c-zoom-image ' + (this.state.isOpen ? 'state-open' : "")} onClick={this.handleZoom}>
						<div className="c-zoom-image__inner">
							<FadeIn duration={250}>
								{onload => (
									<img
										alt={''} 
										src={this.props.image.src} 
										srcSet={this.props.image.srcset} 
										onLoad={onload}
									/>
								)}
							</FadeIn>
						</div>
					</div>
				</Portal>
	    	</div>
			
			
		)
	}
}